export default {"src":"/_next/static/media/facebook_black.70f82f6f.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};